import type { EstimatedDeliveryDateBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import PanelEstimatedDeliveryDateWrap from "./email-panel-wrap";
import { BlockPanelProps } from "../../lib/register-block";

export function EstimatedDeliveryDateEmailPanelRenderer(
  blockProps: BlockPanelProps<EstimatedDeliveryDateBlockProps>,
) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelBlockAlignment />
      <PanelEstimatedDeliveryDateWrap />
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
  );
}
